import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SensorHistoryPopupComponent } from './sensor-history-popup.component';
import {DxLoadPanelModule, DxPopupModule} from 'devextreme-angular';
import {SensorHistoryModule} from '../sensor-history/sensor-history.module';



@NgModule({
  declarations: [SensorHistoryPopupComponent],
  imports: [
    CommonModule,
    DxPopupModule,
    SensorHistoryModule,
    DxLoadPanelModule
  ],
  exports: [SensorHistoryPopupComponent]
})
export class SensorHistoryPopupModule { }
